export class ForecastDataImpl {
    _data;
    _rows;
    constructor(indata) {
        this._data = indata;
        this._rows = indata.rows.map((row) => new SubForecastData(row));
    }
    get id() {
        return this._data.id;
    }
    get name() {
        return this._data.name ?? '-';
    }
    get type() {
        return this._data.type;
    }
    get budget() {
        return this._rows
            .map((r) => r.budget ?? 0)
            .reduce((acc, curr) => {
            return acc + curr;
        }, 0);
    }
    get previousForecast() {
        return this._rows
            .map((r) => r.previousForecast ?? 0)
            .reduce((acc, curr) => {
            return acc + curr;
        }, 0);
    }
    get forecast() {
        return this._rows
            .map((r) => r.forecast ?? 0)
            .reduce((acc, curr) => {
            return acc + curr;
        }, 0);
    }
    get result() {
        return this._rows
            .map((r) => r.result ?? 0)
            .reduce((acc, curr) => {
            return acc + curr;
        }, 0);
    }
    get remaining() {
        return (this.forecast ?? 0) - (this.result ?? 0);
    }
    get budgetLeft() {
        return this._rows
            .map((r) => r.budgetLeft ?? 0)
            .reduce((acc, curr) => {
            return acc + curr;
        }, 0);
    }
    get earnings() {
        return this._rows
            .map((r) => r.earnings ?? 0)
            .reduce((acc, curr) => {
            return acc + curr;
        }, 0);
    }
    get accountTranslation() {
        return this._data.accountTranslation;
    }
    set accountTranslation(value) {
        this._data.accountTranslation = value;
    }
    get comment() {
        return this._data.comment;
    }
    set comment(value) {
        this._data.comment = value;
    }
    get isMissingInBudget() {
        return this._data.isMissingInBudget;
    }
    get ataFixedShouldBeForecasted() {
        return this._data.ataFixedShouldBeForecasted;
    }
    get rows() {
        return this._rows;
    }
}
export class SubForecastData {
    _data;
    _rows;
    constructor(indata) {
        this._data = indata;
        this._rows = indata.rows.map((row) => new ForecastDetailData(row));
    }
    get id() {
        return this._data.id;
    }
    get name() {
        return this._data.name;
    }
    get type() {
        return this._data.type;
    }
    get accountNumber() {
        return this._data.accountNumber;
    }
    get ataNumber() {
        return this._data.ataNumber;
    }
    get budget() {
        return this._data.budget;
    }
    get aggregatedBudget() {
        return this._rows
            .map((r) => r.budget ?? 0)
            .reduce((acc, curr) => {
            return acc + curr;
        }, 0);
    }
    get previousForecast() {
        return this._rows
            .map((r) => r.previousForecast ?? 0)
            .reduce((acc, curr) => {
            return acc + curr;
        }, 0);
    }
    get forecast() {
        return this._rows
            .map((r) => r.forecast ?? 0)
            .reduce((acc, curr) => {
            return acc + curr;
        }, 0);
    }
    get result() {
        return this._rows
            .map((r) => r.result ?? 0)
            .reduce((acc, curr) => {
            return acc + curr;
        }, 0);
    }
    get remaining() {
        return (this.forecast ?? 0) - (this.result ?? 0);
    }
    get budgetLeft() {
        if (this.budget != null && this.result != null) {
            return this.budget - this.result;
        }
        else {
            return null;
        }
    }
    get earnings() {
        if (this.budget != null) {
            const forecastValue = this.forecast === 0 ? this.previousForecast : this.forecast;
            return this.budget - forecastValue;
        }
        else {
            return 0;
        }
    }
    get comment() {
        return this._data.comment;
    }
    set comment(value) {
        this._data.comment = value;
    }
    get rows() {
        return this._rows;
    }
}
export class ForecastDetailData {
    _data;
    constructor(indata) {
        this._data = indata;
    }
    get id() {
        return this._data.id;
    }
    get month() {
        return this._data.month;
    }
    get budget() {
        return this._data.budget;
    }
    set budget(value) {
        this._data.budget = value === '' ? null : value;
    }
    get previousForecast() {
        return this._data.previousForecast;
    }
    get forecast() {
        return this._data.forecast;
    }
    set forecast(value) {
        this._data.forecast = value === '' ? null : value;
    }
    set result(value) {
        this._data.result = value === '' ? null : value;
    }
    get result() {
        return this._data.result;
    }
    get remaining() {
        if (this._data.forecast == null || this._data.result == null)
            return null;
        return this._data.forecast - this._data.result;
    }
    get comment() {
        return this._data.comment;
    }
    set comment(value) {
        this._data.comment = value;
    }
    get outsideOriginalForecast() {
        return this._data.outsideOriginalForecast;
    }
}
